<template>
  <component
    :is="tag"
    class="caption-black-bold"
    :class="{ require: required }"
  >
    {{ title }}
  </component>
</template>

<script setup>
const props = defineProps({
  headingLevel: {
    type: Number,
    required: false,
    default: 4
  },
  title: {
    type: String,
    required: true
  },
  required: {
    type: Boolean,
    required: false,
    default: false
  }
})

const tag = `h${props.headingLevel}`
</script>
